import { ROSELoader } from './rose';

/**
 * @property {Number} boneIdx
 * @property {Number} effectIdx
 */
export class CharacterEffect {
  boneIdx: number = 0;
  effectIdx: number = 0;
}

/**
 * @property {Number[]} models
 * @property {Object} animations
 * @property {CharacterEffect[]} effects
 */
export class Character {
  models: number[] = [];
  animations: any = {};
  effects: CharacterEffect[] = [];
  skeletonIdx: number = 0;
  name: string = '';
}

/**
 * @property {String[]} skeletons
 * @property {String[]} animations
 * @property {String[]} effects
 * @property {Character[]} characters
 */
export class CharacterList {
  // Static references to nested classes for backwards compatibility
  static Character = Character;
  static Effect = CharacterEffect;

  skeletons: string[] = [];
  animations: string[] = [];
  effects: string[] = [];
  characters: (Character | null)[] = [];

  /**
   * @param {String} path
   * @param {Function} callback
   */
  static load(path: any, callback: any) {
    ROSELoader.load(path, (rh: any) => {
      let characters, count, i, j;
      const data = new CharacterList();

      count = rh.readUint16();
      for (i = 0; i < count; ++i) {
        data.skeletons.push(rh.readStr());
      }

      count = rh.readUint16();
      for (i = 0; i < count; ++i) {
        data.animations.push(rh.readStr());
      }

      count = rh.readUint16();
      for (i = 0; i < count; ++i) {
        data.effects.push(rh.readStr());
      }

      characters = rh.readUint16();
      for (i = 0; i < characters; ++i) {
        let character: Character | null = null;

        if (!!rh.readUint8()) {
          character = new Character();
          character.skeletonIdx = rh.readUint16();
          character.name = rh.readStr();

          count = rh.readUint16();
          for (j = 0; j < count; ++j) {
            character.models.push(rh.readUint16());
          }

          count = rh.readUint16();
          for (j = 0; j < count; ++j) {
            const type = rh.readUint16();
            character.animations[type] = rh.readUint16();
          }

          count = rh.readUint16();
          for (j = 0; j < count; ++j) {
            const effect = new CharacterEffect();
            effect.boneIdx = rh.readUint16();
            effect.effectIdx = rh.readUint16();
            character.effects.push(effect);
          }
        }

        data.characters.push(character);
      }

      callback(data);
    });
  }
}
